import { SupportTimeOptions } from "ng-zorro-antd/date-picker/standard-types";
import { NzCalendarI18nInterface, NzDateConfig } from "ng-zorro-antd/i18n";

export type UiDisabledDateFn = (d: Date) => boolean;

type UiDisabledTimePartial = "start" | "end";

export type UiDateMode = "decade" | "year" | "month" | "week" | "date" | "time";

export type UiRangePartType = "left" | "right";

export type UiCompatibleDate = Date | Date[];

export type UiDisabledTimeFn = (current: Date | Date[], partial?: UiDisabledTimePartial) => UiDisabledTimeConfig | undefined;

interface UiDisabledTimeConfig {
  nzDisabledHours(): number[];
  nzDisabledMinutes(hour: number): number[];
  nzDisabledSeconds(hour: number, minute: number): number[];
}

export type UiSupportTimeOptions = SupportTimeOptions;

export interface UiPresetRanges {
  [key: string]: Date[] | (() => Date[]);
}

export type UiCalendarInterface = NzCalendarI18nInterface;

export type UiDateConfig = NzDateConfig;

export const UiAriaLabelMonths = {
  Jan: "january",
  Feb: "february",
  Mar: "march",
  Apr: "april",
  May: "may",
  Jun: "june",
  Jul: "july",
  Aug: "august",
  Sep: "september",
  Oct: "october",
  Nov: "november",
  Dec: "december",
} as const;

export interface UiDateMaxMin {
  minDate: Date;
  maxDate: Date;
}
